// Root promise
let YTPromise;

/**
 * This function given a selector creates a youtube video player on the matching node
 * @param  {String} selector for querySelectorAll
 * @param  {function} onReady callback for when the video is ready
 * @return {Array}
 */
export default function createPlayer(element, id, options) {
  const YT = window.YT;

  // Check to make sure the youtube api is there
  if (!YT) {
    throw Error('youtube API not found on window, it might not have loaded');
  }

  /**
   * Here we wait for YT to finish loading
   */
  if (YT.loaded) {
    return initPlayer(element, id, options);
  } else {
    // If we don't have a promise create one
    if (!YTPromise) {
      YTPromise = new Promise((resolve) => {
        window.onYouTubeIframeAPIReady = resolve;
      });
    }

    // return the promise which resolves when the YTPromise resolves
    return new Promise((resolve) => YTPromise.then(resolve)).then(() => {
      return initPlayer(element, id, options);
    });
  }
}

/**
 * Iterate through each matching node and create a video
 * @param  {String} selector for querySelectorAll
 * @param  {function} onReady callback for when the video is ready
 * @return {Array}
 */
function initPlayer(element, id, options) {
  const YT = window.YT;

  return new Promise((resolve) => {
    const player = new YT.Player(element, {
      height: '100%',
      width: '100%',
      videoId: id,
      playerVars: {
        iv_load_policy: 0,
        rel: 0,
        showinfo: 0,
        ...options
      },
      events: {
        onReady: () => resolve(player)
      }
    });
  });
}
